<template>
  <logged-in-layout>
    <main>
      <h1>Contacts</h1>
      <SearchContacts :features="features" />
    </main>
  </logged-in-layout>
</template>

<script>
import store from '@/lib/store'
import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
import SearchContacts from '@/components/shared/SearchContacts/SearchContacts'

export default {
  components: {
    LoggedInLayout,
    SearchContacts
  },
  data () {
    return {
      team: store.get('team')
    }
  },
  computed: {
    features () {
      const hasSMS = this.team.features.some((feature) => feature.name === 'SMS')
      const features = ['DIAL']

      if (hasSMS) {
        features.push('SMS')
      }

      return features
    }
  }
}
</script>



// WEBPACK FOOTER //
// Contacts.vue?95a00f10